module.exports = __webpack_public_path__ + "img/robot_platform.6276fa9f.png";